export enum Experiment {
    CancelPostOfferAcceptanceABTest = 'YGw__006__cancel_post_offer_acceptance',
}

export enum ActiveGroup {
    A = 'A',
    Default = 'Default',
    Control = 'Control',
}
